var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4367 4.68013C11.4367 7.47575 9.74796 9.875 7.49921 9.875C5.24871 9.875 3.56171 7.47575 3.56171 4.67925C3.56171 1.8845 5.01421 0.25 7.49921 0.25C9.98421 0.25 11.4367 1.88363 11.4367 4.68013ZM0.588464 16.1243C0.925339 16.525 2.37609 17.75 7.49921 17.75C12.6223 17.75 14.0722 16.525 14.41 16.1251C14.4413 16.0867 14.4644 16.0423 14.478 15.9946C14.4915 15.9469 14.4952 15.8969 14.4887 15.8477C14.4117 15.076 13.717 11.625 7.49921 11.625C1.28146 11.625 0.586714 15.076 0.508839 15.8477C0.502502 15.897 0.506297 15.947 0.51999 15.9947C0.533683 16.0424 0.556985 16.0859 0.588464 16.1243Z",
    fill: "#145165"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonal);
export default __webpack_public_path__ + "static/media/personal.8f56a6d9d30074510b65d8ee3f6befe7.svg";
export { ForwardRef as ReactComponent };